
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { Auth0ProviderWithNavigate } from "./auth0-provider-with-navigate";
import { BrowserRouter } from "react-router-dom";

import "assets/scss/black-dashboard-react.scss";
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import 'assets/css/componentStyles/Toolbar.css';
import 'assets/css/componentStyles/JsonCardView.css';
import "assets/css/componentStyles/CustomerInfo.css"

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import { registerLicense } from '@syncfusion/ej2-base';
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF1cWGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEBjW35dcXVQT2BYVEBxWg==');
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX5ednRSQmFeU01yWkY='); 

/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function() {
      navigator.serviceWorker.register('/service-worker.js')
          .then(function(registration) {
              console.log('Service Worker registered with scope:', registration.scope);
          }, function(err) {
              console.log('Service Worker registration failed:', err);
          });
  });
}
if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
  navigator.serviceWorker.controller.postMessage({
    action: 'startCheckingForLogs'
  });
}*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <Auth0ProviderWithNavigate cacheLocation="localstorage">
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </Auth0ProviderWithNavigate>
    </BrowserRouter>
);
